import {
  SET_USERLIST_SHOW,
  SEND_MESSAGE,
  SET_UPLOADED_FILE,
  SET_CONTACT_LIST,
  SET_CONTACT_LIST1,
  SET_CONTACT_LIST2,
  SET_AGENT_LIST,
  SET_EXTERNAL_CHAT_DATA,
  SET_CUSTOMER_TYPING,
  SET_CONTACT_LISTUPDATED,
  SET_CONTACT_LIST_UPDATED1,
  SET_CHAT_SPINNER,
  SET_INTERNAL_CHAT_DATA,
  SET_SEARCH_TERM,
  SET_MSG_TONE,
  SET_MSG_TONE2,
  SET_CHAT_SESSION_ID,
  SET_DIALED_NUMBER_INC,
  SET_AGENT_DIALED_NUMBER,
  SET_SHOW_DIALED_NUMBER,
  SET_SHOW_INCOMING_SCREEN,
  SET_VOICE_AVAILABLE,
  SET_CONSULTED_CONTACT_ID,
  SET_VOICE_SESSION_ID,
  SET_SELETED_VOICE_SESSION_ID,
  SET_SIDEBAR_VAL,
  SET_SHOW_VOICE_CALL,
  SET_VALUE,
  SET_SHOWING_STATUS,
  SET_SHOWING_STATUS_VOICE,
  SET_SHOWING_STATUS_CLASS,
  SET_READY_BUTTON,
  SET_SELECTED_EXTERNAL_CHAT_TYPE,
  SET_ARRIVAL_MESSAGE,
  SET_SELECTED_MENU,
  SET_CUSTOMER_TYPING_ID,
  SET_CLI,
  SET_VOICE_PLAT_FORM,
  SET_WEB_RTC,
  SET_END_CHAT_MODAL_DIALOG,
  SET_DROPDOWN_AGENT_LIST,
  SET_ISBARGINCALL,
  // Reports
  REPORT_AGENTLIST_LOADING,
  REPORT_AGENTLIST_SUCCESS,
  REPORT_AGENTLIST_ERROR,
  REPORT_SKILLSET_LOADING,
  REPORT_SKILLSET_SUCCESS,
  REPORT_SKILLSET_ERROR,

  // Email
  SET_EMAIL_LIST,
  SET_SHOW_EMAIL_LIST,
  SET_SELECTED_MAIL,
  SET_MENTION_LIST,
  SET_MAIL_TYPE,
  SET_EMAIL_LIST_OPTIONS,
  SET_FROM_EMAIL_LIST_OPTIONS,
  SET_EMAIL_TEMPLATE,
  SET_EMAIL_ATTACHMENT,
  SET_COMPOSE_EMAIL_ATTACHMENT,
  SET_CONTACT_LIST_LOADER,
  MISSED_CHATS,
  SET_SHOW_CHAT_FORM,
  SET_SHOW_FORM,
  SET_CHAT_DATA,
  SET_AGENT_LEFT,
  SET_CHAT_TYPE,
  SET_TRANSLATION_LANGUAGE,
} from "./type";

import _, { set } from "lodash";
import {
  AvcUrl,
  BaseUrl,
  BaseUrlReports,
  emailservice,
  PortalUrl,
} from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import { DummyReport } from "../../Components/Utils/Call-utils/call-utils";

export const setReadyButton = (val) => (dispatch) => {
  dispatch({ type: SET_READY_BUTTON, val });
};
export const setArrivalMessage = (val) => (dispatch) => {
  dispatch({ type: SET_ARRIVAL_MESSAGE, val });
};
export const setSelectedMenu = (val) => (dispatch) => {
  dispatch({ type: SET_SELECTED_MENU, val });
};
export const setSelectedExternalChatType = (val) => (dispatch) => {
  dispatch({ type: SET_SELECTED_EXTERNAL_CHAT_TYPE, val });
};
export const setValue = (val) => (dispatch) => {
  dispatch({ type: SET_VALUE, val });
};
export const setShowingStatus = (val) => (dispatch) => {
  dispatch({ type: SET_SHOWING_STATUS, val });
};
export const setShowingStatusVoice = (val) => (dispatch) => {
  dispatch({ type: SET_SHOWING_STATUS_VOICE, val });
};
export const setShowingStatusClass = (val) => (dispatch) => {
  dispatch({ type: SET_SHOWING_STATUS_CLASS, val });
};
export const setUserlistShow = (val) => (dispatch) => {
  dispatch({ type: SET_USERLIST_SHOW, val });
};
export const setsidebarVal = (val) => (dispatch) => {
  dispatch({ type: SET_SIDEBAR_VAL, val });
};
export const setChatSessionId = (val) => (dispatch) => {
  dispatch({ type: SET_CHAT_SESSION_ID, val });
};
export const setMsgTone = (val) => (dispatch) => {
  dispatch({ type: SET_MSG_TONE, val });
};
export const setMsgTone2 = (val) => (dispatch) => {
  dispatch({ type: SET_MSG_TONE2, val });
};
export const setcontactlist = (val) => (dispatch) => {
  dispatch({ type: SET_CONTACT_LIST, val });
};
export const setAgentList = (val) => (dispatch) => {
  dispatch({ type: SET_AGENT_LIST, val });
};
export const sendMessage = (val) => (dispatch) => {
  dispatch({ type: SEND_MESSAGE, val });
};
export const setUploadedFile = (val) => (dispatch) => {
  dispatch({ type: SET_UPLOADED_FILE, val });
};
export const setExternalChatData = (val) => (dispatch) => {
  dispatch({ type: SET_EXTERNAL_CHAT_DATA, val });
};
export const setInternalChatData = (val) => (dispatch) => {
  dispatch({ type: SET_INTERNAL_CHAT_DATA, val });
};
export const setSearchterm = (val) => (dispatch) => {
  dispatch({ type: SET_SEARCH_TERM, val });
};
export const closeNotify = (id, notification) => (dispatch) => {
  let filteredArray = notification.filter((item) => {
    return item.id !== id;
  });
  dispatch({ type: SET_CONTACT_LISTUPDATED, val: filteredArray });
};
export const clearnotifyAll = () => (dispatch) => {
  const emptyNotification = [];
  dispatch({ type: SET_CONTACT_LIST_UPDATED1, emptyNotification });
};
export const clearnotify = () => (dispatch) => {
  dispatch({ type: SET_CONTACT_LIST_UPDATED1, val: [] });
};
export const updateNotification = (msg) => (dispatch) => {
  dispatch({ type: SET_CONTACT_LIST1, val: msg });
};

export const setMessage = (val) => (dispatch) => {
  dispatch({ type: "SET_MESSAGE", val });
};
export const setTypedMessage = (val) => (dispatch) => {
  dispatch({ type: "SET_TYPED_MESSAGE", val });
};

export const setTranslationLanguage = (val) => (dispatch) => {
  dispatch({ type: SET_TRANSLATION_LANGUAGE, val });
};

// Helper function to translate a single message
export const translateSingleMessage = async (message, fromLang, toLang) => {
  try {
    if (!toLang || !toLang.code) {
      return message;
    }

    // Only translate text messages
    if (
      message.msg_sent_type !== "TEXT" &&
      message.msg_sent_type !== undefined
    ) {
      return message;
    }

    const response = await axios.post(
      PortalUrl + "/v1/purple/translateapi",
      {
        content: message.message,
        sourceLanguage: fromLang === "English" ? "en" : toLang.code,
        targetLanguage: toLang.code,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response.data.status && response.data.data.output) {
      return {
        ...message,
        translatedMessage: response.data.data.output,
        translatedLanguage: response.data.data.destinationLanguage,
      };
    }

    return message;
  } catch (error) {
    console.error("Translation error:", error);
    return message;
  }
};

export const setShowEndChatBackDropSpinner = (val) => (dispatch) => {
  dispatch({ type: "SET_SHOW_END_CHAT_BACK_DROP_SPINNER", val });
};

export const setCustomerTyping = (val) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_TYPING, val });
};
export const setChatSpinner = (val) => (dispatch) => {
  dispatch({ type: SET_CHAT_SPINNER, val });
};
export const setCustomerTypingId = (val) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_TYPING_ID, val });
};
export const fetchAgentList = (val) => (dispatch) => {
  dispatch({ type: REPORT_AGENTLIST_LOADING, val });
};

export const setShowChatFullScreen = (val) => (dispatch) => {
  dispatch({ type: "SET_SHOW_CHAT_FULL_SCREEN", val });
};

export const fetchAgentListError = (val) => (dispatch) => {
  dispatch({ type: REPORT_AGENTLIST_ERROR, val });
};
export const fetchSkillsetList = (val) => (dispatch) => {
  dispatch({ type: REPORT_SKILLSET_LOADING, val });
};
export const fetchSkillsetListSuccess = (val) => (dispatch) => {
  dispatch({ type: REPORT_SKILLSET_SUCCESS, val });
};
export const fetchSkillsetListError = (val) => (dispatch) => {
  dispatch({ type: REPORT_SKILLSET_ERROR, val });
};
export const setCurrentTab = (val) => (dispatch) => {
  dispatch({ type: "SET_CURRENT_TAB", val });
};

//Global Function------------------------------------------------
export function skillsetListApiData() {
  return async (dispatch) => {
    await axios
      .post(
        BaseUrlReports + "api/skillsetmasters",
        {
          tenent_id: localStorage.getItem("TenantId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res) {
          console.log(res.data.agents, "reduxapi");
          dispatch(fetchSkillsetListSuccess(res.data.skillsets));
        } else {
          dispatch({ type: REPORT_SKILLSET_ERROR, val: [] });
        }
      })
      .catch((err) => {});
  };
}

export function getAvailableAgentList(type) {
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  return async (dispatch) => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          // user_id: basedOnRole.user_id,
          // type: type,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: "SET_DROPDOWN_AGENT_LIST", val: res.data.data });
        } else {
          dispatch({ type: "SET_DROPDOWN_AGENT_LIST", val: [] });
        }
      })
      .catch((err) => {});
  };
}

//Email channel------------------------------------------------
export const setEmailList = (val) => (dispatch) => {
  dispatch({ type: SET_EMAIL_LIST, val });
};
export const setShowEmailList = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_EMAIL_LIST, val });
};
export const setselectedMail = (val) => (dispatch) => {
  dispatch({ type: SET_SELECTED_MAIL, val });
};
export const setMentionList = (val) => (dispatch) => {
  dispatch({ type: SET_MENTION_LIST, val });
};
export const setMailType = (val) => (dispatch) => {
  dispatch({ type: SET_MAIL_TYPE, val });
};
export const setAttachment = (val) => (dispatch) => {
  dispatch({ type: SET_EMAIL_ATTACHMENT, val });
};
export const setComposeAttachment = (val) => (dispatch) => {
  dispatch({ type: SET_COMPOSE_EMAIL_ATTACHMENT, val });
};
export function fetchEmailList() {
  return async (dispatch) => {
    try {
      await axios
        .post(
          BaseUrl + "/users/getagentaddressbook",
          {
            emailId: "",
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          },
        )
        .then((res) => {
          if (res.data.success) {
            const listEmail = res.data.data;
            const emailList1 = listEmail.map((item) => ({
              value: item.email,
              label: item.email,
            }));

            dispatch({
              type: SET_EMAIL_LIST_OPTIONS,
              val: emailList1,
            });
          } else {
            dispatch({
              type: SET_EMAIL_LIST_OPTIONS,
              val: [],
            });
          }
        });
    } catch (error) {}
  };
}
export function fetchFromEmailList() {
  return async (dispatch) => {
    try {
      await axios
        .post(
          emailservice + "/tenantBasedEmailId",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          },
        )
        .then((res) => {
          if (res.data.status) {
            const listEmail = res.data.data;
            const emailList1 = listEmail.map((item) => ({
              value: item.emailId,
              label: `${item.emailId} - ${item.skillset}`,
            }));

            dispatch({
              type: SET_FROM_EMAIL_LIST_OPTIONS,
              val: emailList1,
            });
          } else {
            dispatch({
              type: SET_FROM_EMAIL_LIST_OPTIONS,
              val: [],
            });
          }
        });
    } catch (error) {}
  };
}
export function SelectTemplate() {
  return async (dispatch) => {
    try {
      axios
        .post(
          BaseUrl + "/userstatus/emailTemplateList",
          {
            organization_id: "13",
            userid: 505,
            pagename: "Masters_viewmasters",
            role_id: 66,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          },
        )
        .then((response) => {
          if (response.data.status) {
            const fetahEmailTemplate = response.data.data;
            const storeEmailTemplate = fetahEmailTemplate.map((item) => ({
              value: item.description,
              label: item.emailtemplate_name,
            }));

            dispatch({
              type: SET_EMAIL_TEMPLATE,
              val: storeEmailTemplate,
            });
          } else {
            dispatch({
              type: SET_EMAIL_TEMPLATE,
              val: [],
            });
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };
}
export function clearAttachmentItem(attachment, attachmentToRemove) {
  return async (dispatch) => {
    if (!attachment && !attachmentToRemove) return;
    const updatedAttachmentlist = attachment.filter(
      (item, index) => index != attachmentToRemove,
    );

    dispatch({ type: SET_EMAIL_ATTACHMENT, val: updatedAttachmentlist });
  };
}
export function clearAttachmentItem2(attachment, attachmentToRemove) {
  return async (dispatch) => {
    if (!attachment && !attachmentToRemove) return;
    const updatedAttachmentlist = attachment.filter(
      (item, index) => index != attachmentToRemove,
    );

    dispatch({
      type: SET_COMPOSE_EMAIL_ATTACHMENT,
      val: updatedAttachmentlist,
    });
  };
}
export const fetchEmail = () => {
  return async (dispatch) => {
    let selectedChat = JSON.parse(localStorage.getItem("client"));
    await axios
      .post(
        emailservice + "/fetchEmailNew",
        {
          ticketID: selectedChat.ticketID,
          agentID: selectedChat.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: "SET_EMAIL_LIST", val: res.data.Data });
        } else {
          dispatch({ type: "SET_EMAIL_LIST", val: [] });
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.error("fetchEmail", error);
      });
  };
};
export const sendMail = (obj) => {
  return async (dispatch) => {
    await axios
      .post(emailservice + "/sendEmail", obj, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.status) {
          toast.success(res.data.message, toaststyle);
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
          dispatch({ type: "SET_EMAIL_ATTACHMENT", val: [] });
          let selectedChat = JSON.parse(localStorage.getItem("client"));

          await axios
            .post(
              emailservice + "/fetchEmailNew",
              {
                ticketID: selectedChat.ticketID,
                agentID: selectedChat.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              },
            )
            .then((res) => {
              if (res.data.status) {
                console.log("fetchEmailNew", res.data.Data);
                dispatch({ type: "SET_EMAIL_LIST", val: res.data.Data });
              } else {
                dispatch({ type: "SET_EMAIL_LIST", val: [] });
                toast.error(res.data.message, toaststyle);
              }
            })
            .catch((error) => {
              console.error("fetchEmail", error);
            });
        } else {
          toast.error(res.data.message, toaststyle);
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
          dispatch({ type: "SET_EMAIL_ATTACHMENT", val: [] });
        }
      })
      .catch((error) => {
        console.log("SendMail", error);
        dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
      });
  };
};
export const forwardMail = (obj) => {
  return async (dispatch) => {
    console.log("obj", obj);
    await axios
      .post(emailservice + "/forwardEmail", obj, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.status) {
          toast.success(res.data.message, toaststyle);
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
          dispatch({ type: "SET_EMAIL_ATTACHMENT", val: [] });
          let selectedChat = JSON.parse(localStorage.getItem("client"));
          await axios
            .post(
              emailservice + "/fetchEmailNew",
              {
                ticketID: selectedChat.ticketID,
                agentID: selectedChat.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              },
            )
            .then((res) => {
              if (res.data.status) {
                console.log("fetchEmailNew", res.data.Data);
                dispatch({ type: "SET_EMAIL_LIST", val: res.data.Data });
              } else {
                dispatch({ type: "SET_EMAIL_LIST", val: [] });
                toast.error(res.data.message, toaststyle);
              }
            })
            .catch((error) => {
              console.error("fetchEmail", error);
            });
        } else {
          toast.success(res.data.message, toaststyle);
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
          dispatch({ type: "SET_EMAIL_ATTACHMENT", val: [] });
        }
      })
      .catch((error) => {
        console.log("SendMail", error);
        dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
      });
  };
};
export const listEmail = (value) => {
  return (dispatch) => {
    // console.log("selected email", value);
    axios
      .post(
        emailservice + "/listEmail",
        {
          id: value.Email._id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        console.log("listEmail", res);
        if (res.data.status) {
          dispatch({
            type: "SET_FORWARDED_EMAIL_LIST",
            val: res.data.EmailList,
          });
          dispatch({ type: "SET_MAIL_TYPE", val: "Forward" });
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: false });
        } else {
          dispatch({
            type: "SET_FORWARDED_EMAIL_LIST",
            val: [],
          });
        }
      })
      .catch((err) => {
        console.log("listEmail", err);
      });
  };
};
export const ApprovelEmail = (obj) => {
  return async (dispatch) => {
    await axios
      .post(emailservice + "/sendEmailApproval", obj, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.status) {
          toast.success(res.data.message, toaststyle);
          const selectedChat = JSON.parse(localStorage.getItem("client"));
          const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/email/endSupervisorMail",
              {
                ticketID: selectedChat.ticketID,
                emailId: selectedChat.emailId,
                user_id: selectedChat.user_id,
                agent_id: loggedInAgent.agent_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              },
            )
            .then(async (res) => {
              if (res.data.success) {
                localStorage.removeItem("client");
                dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: "" });
                // const datas = JSON.parse(localStorage.getItem("tokenAgent"));
                // await axios
                //   .post(
                //     `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
                //     {},
                //     {
                //       headers: {
                //         Authorization:
                //           "Bearer " + localStorage.getItem("access_token"),
                //         "Content-Type": "application/json",
                //         tenantId: localStorage.getItem("TenantId"),
                //       },
                //     }
                //   )
                //   .then((res) => {
                //     if (res.data.length > 0 && res.data) {
                //       localStorage.setItem(
                //         "contactList",
                //         JSON.stringify(res.data)
                //       );
                //       dispatch({ type: SET_CONTACT_LIST, val: res.data });
                //     } else {
                //       localStorage.setItem("contactList", JSON.stringify([]));
                //       dispatch({ type: SET_CONTACT_LIST, val: [] });
                //     }
                //   })
                //   .catch((err) => {});
              }
            })
            .catch((error) => {
              console.error("EndSupervisorMail", error);
            });
        } else {
          toast.success(res.data.message, toaststyle);
          dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
          dispatch({ type: "SET_EMAIL_ATTACHMENT", val: [] });
        }
      })
      .catch((error) => {
        console.log("SendMail", error);
        dispatch({ type: "SET_SHOW_EMAIL_LIST", val: true });
      });
  };
};
//Email channel----------------------------------------------------------------------------

//webchat channel--------------------------------------------------------------------------
export function endInteraction() {
  return async (dispatch) => {
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.length > 0 && res.data) {
          let contactList = JSON.stringify(res.data);
          localStorage.setItem("contactList", contactList);
          dispatch({ type: SET_CHAT_SESSION_ID, val: "" });
          dispatch({ type: SET_EXTERNAL_CHAT_DATA, val: [] });
          dispatch({ type: SET_CONTACT_LIST, val: res.data });
        } else {
          localStorage.setItem("contactList", JSON.stringify([]));
          dispatch({ type: SET_CHAT_SESSION_ID, val: "" });
          dispatch({ type: SET_EXTERNAL_CHAT_DATA, val: [] });
          dispatch({ type: SET_CONTACT_LIST, val: res.data });
        }
      })
      .catch((err) => {});
  };
}
export function GetAllUsers() {
  return async (dispatch) => {
    dispatch({ type: "SET_CONTACT_LIST_LOADER", val: true });
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data && res.data.length > 0) {
          let newdraftmsg = [];
          const draftMessages =
            JSON.parse(localStorage.getItem("DraftMessage")) || [];
          const draftMap = new Map();

          // Map draft messages by `chat_session_id`
          draftMessages.forEach((draft) => {
            draftMap.set(draft.chat_session_id, draft.draftMessage);
          });

          // Process each user record and append draft message if it exists
          res.data.forEach((user) => {
            if (draftMap.has(user.chat_session_id)) {
              user.draftMessage = draftMap.get(user.chat_session_id);
            }
            newdraftmsg.push(user); // Add each user in the order of response
          });

          console.log("newdraftmsg", newdraftmsg);
          localStorage.setItem("contactList", JSON.stringify(newdraftmsg));
          dispatch({ type: SET_CONTACT_LIST, val: newdraftmsg });
        } else {
          // Handle empty data scenario
          localStorage.setItem("contactList", JSON.stringify([]));
          dispatch({ type: "SET_EMAIL_DRAFT_LIST", val: [] });
          localStorage.setItem("DraftEmail", JSON.stringify([]));
          localStorage.setItem("DraftMessage", JSON.stringify([]));
          dispatch({ type: SET_CONTACT_LIST, val: [] });
          dispatch({ type: SET_EXTERNAL_CHAT_DATA, val: "" });
          localStorage.removeItem("client");
        }
        dispatch({ type: "SET_CONTACT_LIST_LOADER", val: false });
      })
      .catch((err) => {
        dispatch({ type: "SET_CONTACT_LIST_LOADER", val: false });
        console.error("Error fetching users:", err);
      });
  };
}
export function GetMissedChats() {
  return async (dispatch) => {
    axios
      .post(
        `${BaseUrl}/users/PurpleQueuedsession`,
        {
          limit: 1000,
          offset: 0,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({ type: MISSED_CHATS, val: res.data.data });
        } else {
          dispatch({ type: MISSED_CHATS, val: [] });
          localStorage.removeItem("client");
        }
      })
      .catch((err) => {});
  };
}
export const updateContactList = (value) => (dispatch) => {
  if (!value) return;
  try {
    // console.log("updated ContactList", value);
    dispatch({ type: SET_CONTACT_LIST, val: value });
    localStorage.setItem("contactList", JSON.stringify(value));
  } catch (error) {
    dispatch({ type: SET_CONTACT_LIST, val: [] });
    localStorage.setItem("contactList", JSON.stringify([]));
    console.log("updateContactList error", error);
  }
};
export function updateAgentList(value) {
  return async (dispatch) => {
    try {
      // console.log("updateAgentList", value);
      if (!value) return;
      // console.log("updateAgentList", value);
      dispatch({ type: SET_AGENT_LIST, val: value });
      localStorage.setItem("agentList", JSON.stringify(value));
    } catch (error) {
      dispatch({ type: SET_AGENT_LIST, val: [] });
      localStorage.setItem("agentList", JSON.stringify([]));
      // console.log("error", error);
    }
  };
}
export function getIncomingChatData() {
  return async (dispatch) => {
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        `${BaseUrl}/users/getIncomingUsers/${datas.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        // console.log("getIncomingChatData", res);
        if (res.data.status) {
          dispatch({ type: SET_CONTACT_LIST2, val: res.data.data });
          localStorage.setItem("incomingChat", JSON.stringify(res.data.data));
        } else {
          dispatch({ type: SET_CONTACT_LIST2, val: [] });
          localStorage.setItem("incomingChat", JSON.stringify([]));
        }
      })
      .catch((err) => {
        // console.log("getIncomingChatData", err);
        dispatch({ type: SET_CONTACT_LIST2, val: [] });
        localStorage.setItem("incomingChat", JSON.stringify([]));
      });
  };
}
export function AddNewChat(value) {
  console.log("AddNewChat", value);
  return async (dispatch) => {
    try {
      if (!value) return;
      // console.log('AddNewChat',value)

      const incomingChat =
        JSON.parse(localStorage.getItem("incomingChat")) || [];

      dispatch({ type: SET_CONTACT_LIST2, val: [...incomingChat, value] });

      localStorage.setItem(
        "incomingChat",
        JSON.stringify([...incomingChat, value]),
      );
    } catch (error) {
      dispatch({ type: SET_CONTACT_LIST2, val: [] });
      // console.log("error", error);
    }
  };
}
export function RemoveAcceptedChat(chatToRemove) {
  return async (dispatch) => {
    try {
      if (!chatToRemove) return;

      // console.log('valuevaluevalue',chatToRemove)

      const updatedIncomingChat = JSON.parse(
        localStorage.getItem("incomingChat"),
      ).filter((item) => item.chat_session_id != chatToRemove.chat_session_id);

      // console.log("updated = IncomingChat", updatedIncomingChat);

      dispatch({ type: SET_CONTACT_LIST2, val: updatedIncomingChat });
      localStorage.setItem("incomingChat", JSON.stringify(updatedIncomingChat));
    } catch (error) {
      dispatch({ type: SET_CONTACT_LIST2, val: [] });
      // console.log("error", error);
    }
  };
}
export function updateStatus(value) {
  return async (dispatch) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data?.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then(async (res) => {
        if (res.data.status) {
          const ExtAvlb = localStorage.getItem("agentLoginTerminalId");
          if (value == "Not Connected") {
            dispatch({ type: SET_SHOWING_STATUS, val: "Connected" });
            localStorage.setItem("AgentStatus", "Connected");
            dispatch({
              type: SET_SHOWING_STATUS_CLASS,
              val: "showStatusConnected",
            });
            dispatch({ type: SET_READY_BUTTON, val: false });
            if (ExtAvlb) {
              await axios
                .post(
                  AvcUrl +
                    `/voice/cct/agent/${localStorage.getItem(
                      "agentLoginTerminalId",
                    )}/status?status=Not Ready`,
                  {},
                  {
                    headers: {
                      ssoToken: localStorage.getItem("ssoToken")
                        ? localStorage.getItem("ssoToken")
                        : "",
                      tenantId: localStorage.getItem("TenantId"),
                    },
                  },
                )
                .then((res) => {
                  if (res.data.status == "OK") {
                    localStorage.setItem(
                      "VoiceStatuslastApiCallTime",
                      Date.now(),
                    );
                    dispatch({
                      type: SET_SHOWING_STATUS_VOICE,
                      val: "Not Ready",
                    });
                    localStorage.setItem("VoiceActivate", "Not Ready");
                  }
                })
                .catch((error) => {
                  dispatch({
                    type: SET_SHOWING_STATUS_VOICE,
                    val: "Not Connected",
                  });
                });
            }
          } else if (value == "ACW") {
            dispatch({ type: SET_SHOWING_STATUS, val: "ACW" });
            localStorage.setItem("AgentStatus", "ACW");
            dispatch({ type: SET_SHOWING_STATUS_CLASS, val: "showStatusRed" });
            dispatch({ type: SET_READY_BUTTON, val: true });
            if (ExtAvlb) {
              await axios
                .post(
                  AvcUrl +
                    `/voice/cct/agent/${localStorage.getItem(
                      "agentLoginTerminalId",
                    )}/status?status=Not Ready`,
                  {},
                  {
                    headers: {
                      ssoToken: localStorage.getItem("ssoToken")
                        ? localStorage.getItem("ssoToken")
                        : "",
                      tenantId: localStorage.getItem("TenantId"),
                    },
                  },
                )
                .then((res) => {
                  if (res.data.status == "OK") {
                    localStorage.setItem(
                      "VoiceStatuslastApiCallTime",
                      Date.now(),
                    );
                    dispatch({
                      type: SET_SHOWING_STATUS_VOICE,
                      val: "Not Ready",
                    });
                    localStorage.setItem("VoiceActivate", "ACW");
                  } else {
                    dispatch({
                      type: SET_SHOWING_STATUS_VOICE,
                      val: "Not Connected",
                    });
                  }
                })
                .catch((error) => {
                  dispatch({
                    type: SET_SHOWING_STATUS_VOICE,
                    val: "Not Connected",
                  });
                });
            }
          } else if (value == "Ready" && ExtAvlb) {
            dispatch({ type: SET_SHOWING_STATUS, val: "Ready" });
            localStorage.setItem("AgentStatus", "Ready");
            dispatch({ type: SET_SHOWING_STATUS_CLASS, val: "showStatus" });
            dispatch({ type: SET_READY_BUTTON, val: true });
            await axios
              .post(
                AvcUrl +
                  `/voice/cct/agent/${localStorage.getItem(
                    "agentLoginTerminalId",
                  )}/status?status=Ready`,
                {},
                {
                  headers: {
                    ssoToken: localStorage.getItem("ssoToken")
                      ? localStorage.getItem("ssoToken")
                      : "",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                },
              )
              .then((res) => {
                if (res.data.status == "OK") {
                  localStorage.setItem(
                    "VoiceStatuslastApiCallTime",
                    Date.now(),
                  );
                  dispatch({ type: SET_SHOWING_STATUS_VOICE, val: "Ready" });
                  localStorage.removeItem("VoiceActivate");
                }
              })
              .catch((error) => {
                dispatch({
                  type: SET_SHOWING_STATUS_VOICE,
                  val: "Not Connected",
                });
              });
          } else {
            dispatch({ type: SET_SHOWING_STATUS, val: value });
            localStorage.setItem("AgentStatus", value);
            dispatch({ type: SET_SHOWING_STATUS_CLASS, val: "showStatusRed" });
            dispatch({ type: SET_READY_BUTTON, val: true });
            if (ExtAvlb) {
              await axios
                .post(
                  AvcUrl +
                    `/voice/cct/agent/${localStorage.getItem(
                      "agentLoginTerminalId",
                    )}/status?status=Not Ready`,
                  {},
                  {
                    headers: {
                      ssoToken: localStorage.getItem("ssoToken")
                        ? localStorage.getItem("ssoToken")
                        : "",
                      tenantId: localStorage.getItem("TenantId"),
                    },
                  },
                )
                .then((res) => {
                  if (res.data.status == "OK") {
                    localStorage.setItem(
                      "VoiceStatuslastApiCallTime",
                      Date.now(),
                    );
                    dispatch({
                      type: SET_SHOWING_STATUS_VOICE,
                      val: "Not Ready",
                    });
                    localStorage.setItem("VoiceActivate", value);
                  } else {
                    dispatch({
                      type: SET_SHOWING_STATUS_VOICE,
                      val: "Not Connected",
                    });
                  }
                })
                .catch((error) => {
                  dispatch({
                    type: SET_SHOWING_STATUS_VOICE,
                    val: "Not Connected",
                  });
                });
            }
          }
        } else {
          console.log("updateStatus", res);
        }
      })
      .catch((err) => {
        console.log("updateStatus", err);
      });
  };
}
export function insertAndShift(arr, from, to) {
  let cutOut = arr.splice(from, 1)[0];
  arr.splice(to, 0, cutOut);
  return arr;
}

export const updateLastMes = async (id, msg, date, count) => {
  let data_to_pass = {
    id: id,
    lastMsg: msg,
    time: date,
    count: count,
  };

  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
      tenantId: localStorage.getItem("TenantId"),
    },
  };
  await axios
    .post(BaseUrl + "/message/updateLastMessage", data_to_pass, header)
    .then((res) => {})
    .catch((err) => {
      // console.log("updateLastMes", err);
    });
};

export function showLastMsgExternal(msg, playSound, playMsgTone) {
  return async (dispatch) => {
    if (!msg) return;
    // console.log("msg", msg);
    // const decryptedBytes = CryptoJS.AES.decrypt(msg.msg, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client")) || {};
      var newcontactlist = [];
      var unread_count = 0;
      var find = 0;
      let newupdatedlist;

      JSON.parse(localStorage.getItem("contactList")).map((client, index) => {
        if (client.id == msg.from) {
          find = index;

          if ((selectedChat ? selectedChat.id : "") !== client.id) {
            if (client.unreadcount) {
              unread_count = client.unreadcount + 1;
            } else {
              unread_count = 1;
            }
            playSound();

            var newNotification = {
              id: msg.from,
              username: msg.chatdetails.unique_id.username,
              client_msg: msg.msg,
              from_id: msg.from,
              chatType: "External",
            };

            console.log("msg", newNotification);

            dispatch({ type: SET_CONTACT_LIST1, val: newNotification });
          } else {
            playMsgTone();
          }

          client.lastmessage = msg.msg;
          client.lastmessagetime = moment().format("h:mm A");
          client.lastmessageUpdatedat = moment();
          client.unreadcount = unread_count;
          client.currentChat = client.id == msg.from ? true : false;
          updateLastMes(
            client.id,
            msg.msg,
            moment().format("h:mm A"),
            unread_count,
          );
        }

        if (
          (msg.conference && client.id == msg.conference_id) ||
          (msg.conference && client.id == msg.to)
        ) {
          find = index;
          if ((selectedChat ? selectedChat.id : "") !== client.id) {
            if (client.unreadcount) {
              unread_count = client.unreadcount + 1;
            } else {
              unread_count = 1;
            }
            playSound();

            // console.log("hello2");
            var newNotification = {
              id: msg.from,
              username: msg.senderName,
              client_msg: msg.msg,
              from_id: msg.from,
              chatType: msg.chatType,
            };
            dispatch({ type: SET_CONTACT_LIST1, val: newNotification });
          } else {
            playMsgTone();
          }

          client.lastmessage = msg.msg;
          client.lastmessagetime = moment().format("h:mm A");
          client.lastmessageUpdatedat = moment();
          client.unreadcount = unread_count;
          client.currentChat = client.id == msg.from ? true : false;

          updateLastMes(
            client.id,
            msg.msg,
            moment().format("h:mm A"),
            unread_count,
          );
        }
        newcontactlist.push(client);
      });

      if (find != 0) {
        newupdatedlist = insertAndShift(newcontactlist, find, 0);
      } else {
        newupdatedlist = newcontactlist;
      }

      dispatch({ type: SET_CONTACT_LIST, val: [...newupdatedlist] });
      localStorage.setItem("contactList", JSON.stringify([...newupdatedlist]));
    } catch (error) {
      console.log("update last message recived", error);
    }
  };
}
export function showLastMsgInternal(msg, playSound, playMsgTone) {
  return async (dispatch) => {
    if (!msg) return;
    // const decryptedBytes = CryptoJS.AES.decrypt(msg.msg, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    console.log("internal msg", msg);
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client")) || {};
      var newcontactlist = [];
      var unread_count = 0;
      var find = 0;
      let newagent;
      JSON.parse(localStorage.getItem("agentList")).map((client, index) => {
        if (msg.chatType === "inbound") {
          if (client._id === msg.chatdetails._id) {
            find = index;
            // console.log("client inbound", client);
            // console.log("client inbound msg", msg);
            if (
              selectedChat.chat_session_id != msg.chatdetails.chat_session_id
            ) {
              if (client.unreadcount) {
                unread_count = client.unreadcount + 1;
              } else {
                unread_count = 1;
              }
              playSound();
              var newNotification = {
                id: msg.from,
                username: msg.senderName,
                client_msg: msg.msg,
                from_id: msg.from,
                chatType: msg.chatType,
              };
              dispatch({ type: SET_CONTACT_LIST1, val: newNotification });
            } else {
              playMsgTone();
            }
            client.lastmessage = msg.msg;
            client.lastmessagetime = moment().format("h:mm A");
            client.unreadcount = unread_count;
            client.currentChat = client.id == msg.from ? true : false;

            updateLastMes(
              client.id,
              msg.msg,
              moment().format("h:mm A"),
              unread_count,
            );
          }
        } else {
          if (client._id === msg.chatdetails._id) {
            find = index;
            // console.log("client outbound", client);
            // console.log("client outbound msg", msg);

            if (
              selectedChat.chat_session_id != msg.chatdetails.chat_session_id
            ) {
              if (client.unreadcount) {
                unread_count = client.unreadcount + 1;
              } else {
                unread_count = 1;
              }
              playSound();
              var newNotification = {
                id: msg.from,
                username: msg.senderName,
                client_msg: msg.msg,
                from_id: msg.from,
                chatType: msg.chatType,
              };
              dispatch({ type: SET_CONTACT_LIST1, val: newNotification });
            } else {
              playMsgTone();
            }
            client.lastmessage = msg.msg;
            client.lastmessagetime = moment().format("h:mm A");
            client.unreadcount = unread_count;
            client.currentChat = client.id == msg.from ? true : false;

            updateLastMes(
              client.id,
              msg.msg,
              moment().format("h:mm A"),
              unread_count,
            );
          }
        }
        newcontactlist.push(client);
      });

      if (find != 0) {
        newagent = insertAndShift(newcontactlist, find, 0);
      } else {
        newagent = newcontactlist;
      }
      // console.log("newagent", newagent);
      dispatch({ type: SET_AGENT_LIST, val: newagent });
      localStorage.setItem("agentList", JSON.stringify(newagent));
    } catch (error) {
      // console.log("showLastMsgInternal", error);
    }
  };
}
export function updateSetExternalChatData(value) {
  return async (dispatch) => {
    try {
      // console.log("updateSetExternalChatData", value);
      dispatch({
        type: SET_EXTERNAL_CHAT_DATA,
        val: { ...value, is_customer_disconnected: true },
      });
      localStorage.setItem(
        "client",
        JSON.stringify({ ...value, is_customer_disconnected: true }),
      );
    } catch (error) {}
  };
}
export function EndChat(externalChatData) {
  return async (dispatch) => {
    if (externalChatData.channel === "voice") {
      if (externalChatData.direction == "Outbound") {
        localStorage.setItem("statusValue", "Outbound");
        localStorage.setItem("VoiceActivate", true);
      } else {
        localStorage.setItem("statusValue", "Ready");
        localStorage.setItem("VoiceActivate", true);
      }
    }
    let data = {
      chat_session_id: externalChatData.chat_session_id,
      chatendby: "Agent",
      reason: "No disposition",
      comment: "",
      agent_id: JSON.parse(localStorage.getItem("tokenAgent")).id,
    };
    await axios
      .post(BaseUrl + "/message/endchat", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.success) {
          const contactList = JSON.parse(localStorage.getItem("contactList"));
          const updatedContactList = contactList.filter(
            (item) => item.chat_session_id != externalChatData.chat_session_id,
          );
          localStorage.setItem(
            "contactList",
            JSON.stringify(updatedContactList),
          );

          dispatch({ type: SET_CONTACT_LIST, val: updatedContactList });
          dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: "" });
          dispatch({ type: "SET_SHOW_END_CHAT_BACK_DROP_SPINNER", val: false });
          localStorage.removeItem("client");
          localStorage.removeItem("observing");
          localStorage.removeItem("callActivate");
          localStorage.removeItem("type");
          localStorage.removeItem("ContactVoiceId");
          localStorage.removeItem("Contactreg_no");
          toast.success("Interaction Ended Successfully", toaststyle);
        } else {
          dispatch({ type: "SET_SHOW_END_CHAT_BACK_DROP_SPINNER", val: false });
          dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: "" });
          toast.error("Something Went Wrong", toaststyle);
        }
      })
      .catch((error) => {
        toast.error("Something Went Wrong", toaststyle);
        dispatch({ type: "SET_SHOW_END_CHAT_BACK_DROP_SPINNER", val: false });
        dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: "" });
      });
  };
}
export const ErrorNotification = (headerMsg, msg) => {
  return async (dispatch) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };

    dispatch({ type: SET_CONTACT_LIST1, val: newNotification });
  };
};
export const UpdateExternalContactList = (chatSessionId) => {
  return async (dispatch) => {
    const contactList = JSON.parse(localStorage.getItem("contactList"));
    const updatedContactList = contactList.filter(
      (item) => item.chat_session_id != chatSessionId,
    );
    dispatch({ type: SET_CONTACT_LIST, val: updatedContactList });
    localStorage.setItem("contactList", JSON.stringify(updatedContactList));

    if (updatedContactList.length > 0) {
      localStorage.setItem("client", JSON.stringify(updatedContactList[0]));
      dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: updatedContactList[0] });
      dispatch({
        type: "SET_CHAT_SESSION_ID",
        val: updatedContactList[0].chat_session_id,
      });
    } else {
      dispatch({ type: "SET_EXTERNAL_CHAT_DATA", val: "" });
    }
  };
};
export const AddChatToExternalContactList = (IncomingRequest) => {
  return async (dispatch) => {
    const contactList =
      [...JSON.parse(localStorage.getItem("contactList"))] || [];
    contactList.unshift(IncomingRequest);
    dispatch({ type: SET_CONTACT_LIST, val: contactList });
    localStorage.setItem("contactList", JSON.stringify(contactList));
  };
};
export const CreateDraftMessageForEmail = (message, mail) => (dispatch) => {
  console.log("email draft", message);
  console.log("perticular mail", mail);

  return;
  let selectedChat = JSON.parse(localStorage.getItem("client")) || {};
  let newcontactList = [];
  JSON.parse(localStorage.getItem("contactList")).map((client) => {
    if (client.id === selectedChat.id) {
      client.draftMessage = message;
    }
    newcontactList.push(client);
  });
  dispatch({ type: SET_CONTACT_LIST, val: newcontactList });
  localStorage.setItem("contactList", JSON.stringify(newcontactList));
};

export const CreateExternalDraftMessage =
  (selectedChat, message) => (dispatch) => {
    if (!selectedChat || !selectedChat.chat_session_id) return;

    const draftMessage = JSON.parse(
      localStorage.getItem("DraftMessage") || "[]",
    );

    if (draftMessage.length === 0) {
      localStorage.setItem(
        "DraftMessage",
        JSON.stringify([
          {
            chat_session_id: selectedChat.chat_session_id,
            draftMessage: message,
          },
        ]),
      );
      dispatch(updateDraftToContactList(selectedChat, message));
      return;
    }

    const DftMsgPst = draftMessage.find(
      (DfrMsg) => DfrMsg.chat_session_id === selectedChat.chat_session_id,
    );

    if (DftMsgPst) {
      const updatedDraftMessage = draftMessage.map((DftMsg) =>
        DftMsg.chat_session_id === selectedChat.chat_session_id
          ? { ...DftMsg, draftMessage: message }
          : DftMsg,
      );

      localStorage.setItem("DraftMessage", JSON.stringify(updatedDraftMessage));
      dispatch(updateDraftToContactList(selectedChat, message));
    } else {
      localStorage.setItem(
        "DraftMessage",
        JSON.stringify([
          ...draftMessage,
          {
            chat_session_id: selectedChat.chat_session_id,
            draftMessage: message,
          },
        ]),
      );
      dispatch(updateDraftToContactList(selectedChat, message));
    }
  };

const updateDraftToContactList = (selectedChat, message) => (dispatch) => {
  let newcontactList = [];
  JSON.parse(localStorage.getItem("contactList") || "[]").map((client) => {
    if (client.id === selectedChat.id) {
      client.draftMessage = message;
    }
    newcontactList.push(client);
  });
  dispatch({ type: SET_CONTACT_LIST, val: newcontactList });
  localStorage.setItem("contactList", JSON.stringify(newcontactList));
};
export const RemoveExternalDraftMessage = (selectedChat) => (dispatch) => {
  if (!selectedChat) return;
  const draftMessage = JSON.parse(localStorage.getItem("DraftMessage") || "[]");
  const updaterDftMsg = draftMessage.filter(
    (dftMsg) => selectedChat.chat_session_id != dftMsg.chat_session_id,
  );
  localStorage.setItem("DraftMessage", JSON.stringify(updaterDftMsg));
  dispatch(updateDraftToContactList(selectedChat, ""));
};
export const CreateInternalDraftMessage = (message) => (dispatch) => {
  let selectedChat = JSON.parse(localStorage.getItem("client")) || {};
  let newagent = [];
  JSON.parse(localStorage.getItem("agentList")).map((client) => {
    if (client.id === selectedChat.id) {
      client.draftMessage = message;
    }
    newagent.push(client);
  });
  dispatch({ type: SET_AGENT_LIST, val: newagent });
  localStorage.setItem("agentList", JSON.stringify(newagent));
};

// voice channel ----------------------------------------------------------------------------------------------------
export const setVoiceAvailable = (val) => (dispatch) => {
  dispatch({ type: SET_VOICE_AVAILABLE, val });
};
export const setDialedNumberInc = (val) => (dispatch) => {
  dispatch({ type: SET_DIALED_NUMBER_INC, val });
};
export const setshowIncommingscreen = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_INCOMING_SCREEN, val });
};
export const setagentDialedNumber = (val) => (dispatch) => {
  dispatch({ type: SET_AGENT_DIALED_NUMBER, val });
};
export const setshowphonedialer = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_DIALED_NUMBER, val });
};
export const setconsultedContactId = (val) => (dispatch) => {
  dispatch({ type: SET_CONSULTED_CONTACT_ID, val });
};
export const setVoiceSessionId = (val) => (dispatch) => {
  dispatch({ type: SET_VOICE_SESSION_ID, val });
};
export const setseletedVoiceSessionId = (val) => (dispatch) => {
  dispatch({ type: SET_SELETED_VOICE_SESSION_ID, val });
};
export const setShowVoiceCall = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_VOICE_CALL, val });
};
export const setCli = (val) => (dispatch) => {
  dispatch({ type: SET_CLI, val });
};
export const setVoicePlatForm = (val) => (dispatch) => {
  dispatch({ type: SET_VOICE_PLAT_FORM, val });
};
export const setWebRTC = (val) => (dispatch) => {
  dispatch({ type: SET_WEB_RTC, val });
};
export const setendchatModalDialog = (val) => (dispatch) => {
  dispatch({ type: SET_END_CHAT_MODAL_DIALOG, val });
};
export const setCallList = (val) => (dispatch) => {
  dispatch({ type: "SET_CALL_LIST", val });
};
export const setIsBarginCall = (val) => (dispatch) => {
  dispatch({ type: SET_ISBARGINCALL, val });
};

export const addCallToList = (responseData) => async (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  await axios
    .post(
      BaseUrl + "/users/callcreateSession",
      {
        name: "",
        email_id: "",
        phone:
          responseData.callType == "Inbound"
            ? responseData.callerId
            : responseData.calledDeviceID,
        channel: "voice",
        latitude: "",
        longitute: "",
        skillset: responseData.skillSet == null ? "NA" : responseData.skillSet,
        language: "English",
        complaint: "",
        agent_id: JSON.parse(localStorage.getItem("tokenAgent")).id,
        agent_extension: localStorage.getItem("AvayaUsername"),
        direction:
          localStorage.getItem("ClickToCall") == "true"
            ? localStorage.getItem("callDirectionType")
            : responseData.callType,
        contactId: responseData.contactId,
        UUID_contactId: responseData.contactId,
        UUID_externalContactId: responseData.externalContactId,
        UUID_calledDeviceID:
          responseData.callType == "Inbound"
            ? responseData.calledDeviceID
            : localStorage.getItem("agentLoginTerminalId"),
        UUID_callingDeviceID: responseData.UUID_callingDeviceID,
        UUID_callingAgentName: responseData.callingAgentName,
        UUID_skillSet:
          responseData.skillSet == null ? "NA" : responseData.skillSet,
        callArrivalTime: localStorage.getItem("callArrivalTime"),
        observeAgent: localStorage.getItem("Bargin") == "true" ? true : false,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      },
    )
    .then((res) => {
      if (res.data.status == true) {
        newCallList.unshift({
          Mute: true,
          Hold: true,
          Dialer: true,
          AssistSupervisor: true,
          Transfer: false,
          Merge: false,
          Bargin: localStorage.getItem("Bargin") == "true" ? true : false,
          Couch: false,
          inConference: false,
          phone:
            responseData.callType == "Inbound"
              ? responseData.callerId
              : responseData.calledDeviceID,
          ...responseData,
        });
        localStorage.setItem("contactId", responseData.contactId);
        localStorage.removeItem("Bargin");
        localStorage.removeItem("callArrivalTime");
        let voiceuser = res.data.data[0];
        dispatch({
          type: SET_VOICE_SESSION_ID,
          val: voiceuser.chat_session_id,
        });
        dispatch({
          type: SET_CHAT_SESSION_ID,
          val: voiceuser.chat_session_id,
        });
        dispatch({ type: "SET_CALL_LIST", val: newCallList });
        localStorage.setItem("callList", JSON.stringify(newCallList));
        localStorage.setItem("client", JSON.stringify(voiceuser));
        dispatch({ type: SET_EXTERNAL_CHAT_DATA, val: voiceuser });
        const contactList =
          [...JSON.parse(localStorage.getItem("contactList"))] || [];
        contactList.unshift(voiceuser);
        dispatch({ type: SET_CONTACT_LIST, val: contactList });
        localStorage.setItem("contactList", JSON.stringify(contactList));
        JSON.parse(localStorage.getItem("permission")).map((module) => {
          if (module.moduleName === "INTERACTION") {
            const value = module.screen.some(
              (item) =>
                item.screenId === "CRM_VOICE" && item.read && item.write,
            );

            if (value && localStorage.getItem("ClickToCall") == "true") {
              dispatch({ type: "SET_CURRENT_TAB", val: "Crm" });
            }
          }
        });
        JSON.parse(localStorage.getItem("permission")).map((module) => {
          if (module.moduleName === "INTERACTION") {
            const value = module.screen.some(
              (item) =>
                item.screenId === "IVR_SURVEY" && item.read && item.write,
            );

            if (
              value &&
              responseData.callType == "Inbound" &&
              responseData.callerId.length > 5
            ) {
              dispatch(
                IVRSurvey({
                  uniqueid: responseData.contactId,
                  agentextn: localStorage.getItem("agentLoginTerminalId"),
                  agentname: localStorage.getItem("AvayaUsername"),
                  skillset: responseData.skillSet,
                }),
              );
            }
          }
        });
      } else {
        toast.error("Something Went Wrong", toaststyle);
      }
    })
    .catch((err) => {
      console.log("createVoiceSession", err);
    });
};

const IVRSurvey = (value) => (dispatch) => {
  let body = {
    uniqueid: value.uniqueid,
    agentextn: value.agentextn,
    agentname: value.agentname,
    skillset: value.skillset,
  };
  axios
    .post(BaseUrl + "/ivrservice/surveyOpt", body, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
        tenantId: localStorage.getItem("TenantId"),
      },
    })
    .then((res) => {
      let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
      if (res.data.status) {
        dispatch({
          type: "SET_CALL_LIST",
          val: [
            {
              ...newCallList[0],
              surveyOpt: true,
              surveyOptForwardNumber: res.data.data.TransferNumber,
            },
          ],
        });
        localStorage.setItem(
          "callList",
          JSON.stringify([
            {
              ...newCallList[0],
              surveyOpt: true,
              surveyOptForwardNumber: res.data.data.TransferNumber,
            },
          ]),
        );
      } else {
        dispatch({
          type: "SET_CALL_LIST",
          val: [
            {
              ...newCallList[0],
              surveyOpt: false,
            },
          ],
        });
        localStorage.setItem(
          "callList",
          JSON.stringify([
            {
              ...newCallList[0],
              surveyOpt: false,
            },
          ]),
        );
      }
    })
    .catch((error) => {});
};

export const add2CallToList = (responseData) => (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  newCallList.unshift({
    Mute: true,
    Hold: true,
    ...responseData,
  });
  dispatch({ type: "SET_CALL_LIST", val: newCallList });
  localStorage.setItem("callList", JSON.stringify(newCallList));
};
export const removeCallFromList = (responseData) => (dispatch) => {
  return new Promise((onResolve, Error) => {
    var modifyCallList = [];
    let callList = JSON.parse(localStorage.getItem("callList")) || [];
    const existingCall = callList.find(
      (call) => call.contactId === responseData.contactId,
    );
    if (existingCall) {
      if (callList.length != 1) {
        const diconnectedCall = callList.filter(
          (call) => call.contactId == responseData.contactId,
        );
        console.log("diconnectedCall", diconnectedCall);
        if (diconnectedCall[0].callType == "ConsultConference") {
          console.log("remove consulted call");
          const newCallList = callList.filter((call) => {
            return call.contactId != responseData.contactId;
          });
          var switchMainCallAction = [];
          if (newCallList.length == 1) {
            newCallList.map((call) => {
              call.Hold = false;
              call.Dialer = true;
              call.AssistSupervisor = true;
              call.Transfer = false;
              call.Merge = false;
              switchMainCallAction.push(call);
            });
            // unhold_call(newCallList[0].contactId);
          }
          dispatch({ type: "SET_CALL_LIST", val: switchMainCallAction });
          localStorage.setItem(
            "callList",
            JSON.stringify(switchMainCallAction),
          );
          onResolve({ status: false });
        } else {
          console.log("swap consulted call to main call");
          const newCallList = callList.filter(
            (call) => call.contactId != responseData.contactId,
          );
          var swapCallFrom2to1 = [];
          newCallList.map((call) => {
            call.Mute = true;
            call.Hold = true;
            call.Dialer = true;
            call.AssistSupervisor = true;
            call.Transfer = false;
            call.Merge = false;
            call.Bargin = false;
            call.Couch = false;
            call.callType = "OutBound";
            swapCallFrom2to1.push(call);
          });
          dispatch({ type: "SET_CALL_LIST", val: swapCallFrom2to1 });
          localStorage.setItem("callList", JSON.stringify(swapCallFrom2to1));
          onResolve({ status: false });
        }
      } else {
        console.log("Main call Removed", responseData);
        const newCallList = callList.filter(
          (call) => call.contactId != responseData.contactId,
        );
        const endedCall = callList.filter(
          (call) => call.contactId == responseData.contactId,
        );
        modifyCallList.push(newCallList);
        dispatch({ type: "SET_CALL_LIST", val: newCallList });
        localStorage.setItem("callList", JSON.stringify(newCallList));
        onResolve({ status: true, responseData: endedCall[0] });
      }
    }
  });
};
export const callTransfered = (responseData) => (dispatch) => {
  return new Promise((onResolve, Error) => {
    let callList = JSON.parse(localStorage.getItem("callList")) || [];
    if (callList.length == 2) {
      dispatch({ type: "SET_CALL_LIST", val: [] });
      localStorage.setItem("callList", JSON.stringify([]));
      onResolve({ status: true, responseData: callList[1] });
    } else {
      onResolve({ status: false, responseData });
    }
  });
};
// old code
// export const callConferanced = (responseData) => (dispatch) => {
//   let callList = JSON.parse(localStorage.getItem("callList")) || [];
//   if (callList.length == 2) {
//     console.log("agent made a conferance call");
//     dispatch({ type: "SET_CALL_LIST", val: callList });
//     localStorage.setItem("callList", JSON.stringify(callList));
//   } else {
//       console.log("call get conferance");
//       let callList = JSON.parse(localStorage.getItem("callList")) || [];
//       var modifyCallList = [];
//       callList.map((call) => {
//         call.Mute = true;
//         call.Hold = true;
//         call.Dialer = true;
//         call.AssistSupervisor = true;
//         call.Transfer = false;
//         call.Merge = false;
//         call.Bargin = false;
//         call.Couch = false;
//         call.callType = responseData.callType;
//         call.calledDeviceID = responseData.calledDeviceID;
//         call.callerId = responseData.callerId;
//         call.callingAgentName = responseData.callingAgentName;
//         call.callingDeviceID = responseData.callingDeviceID;
//         call.contactId = responseData.contactId;
//         call.event = responseData.event;
//         call.externalContactId = responseData.externalContactId;
//         call.mainContactId = null;
//         call.reason = responseData.reason;
//         call.skillSet = responseData.skillSet;
//         call.thirdPartyDeviceID = responseData.thirdPartyDeviceID;
//         call.uuiData = responseData.uuiData;
//         modifyCallList.push(call);
//       });
//       let newcontactlist = [];
//       JSON.parse(localStorage.getItem("contactList")).map((client) => {
//         if (client.voice_contactId == localStorage.getItem("contactId")) {
//           client.voice_contactId = localStorage.getItem("mainContactId");
//           client.phonenumber = responseData.callingDeviceID;
//           client.unique_id.phonenumber = responseData.callingDeviceID;

//           try {
//             const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
//             axios
//               .post(
//                 BaseUrl + "/users/updateClient",
//                 {
//                   id: client.unique_id.id,
//                   agent_id: loggedInAgent.id,
//                   chat_session_id: client.chat_session_id,
//                   phonenumber: responseData.callingDeviceID,
//                   voice_contactId: localStorage.getItem("mainContactId"),
//                 },
//                 {
//                   headers: {
//                     Authorization:
//                       "Bearer " + localStorage.getItem("access_token"),
//                     "Content-Type": "application/json",
//                     tenantId: localStorage.getItem("TenantId"),
//                   },
//                 }
//               )
//               .then((res) => {
//                 if (res.data.status) {
//                   dispatch({
//                     type: SET_EXTERNAL_CHAT_DATA,
//                     val: res.data.session[0],
//                   });
//                 } else {
//                 }
//               })
//               .catch((error) => { });
//           } catch (error) { }
//         }
//         newcontactlist.push(client);
//       });
//       localStorage.setItem("contactId", localStorage.getItem("mainContactId"));
//       dispatch({ type: SET_CONTACT_LIST, val: [...newcontactlist] });
//       localStorage.setItem("contactList", JSON.stringify([...newcontactlist]));
//       localStorage.setItem("incomingNumber", responseData.callingDeviceID);
//       dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
//       localStorage.setItem("callList", JSON.stringify(modifyCallList));
//       localStorage.removeItem("mainContactId");
//   }
// };

export const callConferanced = (responseData) => async (dispatch) => {
  const MAX_RETRIES = 10;
  let attempts = 0;

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const updateClient = async (client) => {
    try {
      const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
      const response = await axios.post(
        `${BaseUrl}/users/updateClient`,
        {
          id: client.unique_id.id,
          agent_id: loggedInAgent.id,
          chat_session_id: client.chat_session_id,
          phonenumber: responseData.callingDeviceID,
          voice_contactId: localStorage.getItem("mainContactId"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      );
      if (response.data.status) {
        dispatch({
          type: SET_EXTERNAL_CHAT_DATA,
          val: response.data.session[0],
        });
      }
    } catch (error) {
      console.error("updateClient error", error);
    }
  };

  const processUpdate = async () => {
    let callList = JSON.parse(localStorage.getItem("callList")) || [];
    if (callList.length === 2) {
      console.log("Agent made a conference call");
      dispatch({ type: "SET_CALL_LIST", val: callList });
      localStorage.setItem("callList", JSON.stringify(callList));
      return;
    }

    while (attempts < MAX_RETRIES) {
      let callList = JSON.parse(localStorage.getItem("callList")) || [];
      const contactList = JSON.parse(localStorage.getItem("contactList")) || [];
      const contactId = localStorage.getItem("contactId");
      const mainContactId = localStorage.getItem("mainContactId");
      if (responseData && callList.length && contactList.length) {
        const modifiedCalls = callList.map((call) => ({
          ...call,
          Mute: true,
          Hold: true,
          Dialer: true,
          AssistSupervisor: true,
          Transfer: false,
          Merge: false,
          Bargin: false,
          Couch: false,
          callType: responseData.callType,
          calledDeviceID: responseData.calledDeviceID,
          callerId: responseData.callerId,
          callingAgentName: responseData.callingAgentName,
          callingDeviceID: responseData.callingDeviceID,
          contactId: responseData.contactId,
          event: responseData.event,
          externalContactId: responseData.externalContactId,
          mainContactId: null,
          reason: responseData.reason,
          skillSet: responseData.skillSet,
          thirdPartyDeviceID: responseData.thirdPartyDeviceID,
          uuiData: responseData.uuiData,
        }));

        const newContactList = await Promise.all(
          contactList.map(async (client) => {
            if (client.voice_contactId === contactId) {
              client.voice_contactId = mainContactId;
              client.phonenumber = responseData.callingDeviceID;
              client.unique_id.phonenumber = responseData.callingDeviceID;
              await updateClient(client);
            }
            return client;
          }),
        );
        console.log("modifiedCalls", modifiedCalls);
        localStorage.setItem("contactId", mainContactId);
        dispatch({ type: SET_CONTACT_LIST, val: newContactList });
        localStorage.setItem("contactList", JSON.stringify(newContactList));
        localStorage.setItem("incomingNumber", responseData.callingDeviceID);
        dispatch({ type: "SET_CALL_LIST", val: modifiedCalls });
        localStorage.setItem("callList", JSON.stringify(modifiedCalls));
        localStorage.removeItem("mainContactId");
        return;
      }

      attempts++;
      console.log(`Waiting for localStorage data... retry ${attempts}`);
      await wait(1500);
    }

    console.warn("Failed to fetch required data after multiple retries.");
  };

  await processUpdate();
};

export const removeSecondCallFromConferance = (responseData) => (dispatch) => {
  let callList = JSON.parse(localStorage.getItem("callList")) || [];

  if (callList.length == 2) {
    const mainCall = callList.filter(
      (call) => call.contactId != responseData.contactId,
    );
    var modifyCallList = [];
    mainCall.map((call) => {
      call.Mute = true;
      call.Hold = true;
      call.Dialer = true;
      call.AssistSupervisor = true;
      call.Transfer = false;
      call.Merge = false;
      call.inConferance = true;
      modifyCallList.push(call);
    });
    dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
    localStorage.setItem("callList", JSON.stringify(modifyCallList));
  } else if (callList.length == 0) {
    const mainCall = callList.filter(
      (call) => call.contactId != responseData.contactId,
    );
    var modifyCallList = [];
    mainCall.map((call) => {
      call.Mute = true;
      call.Hold = true;
      call.Dialer = true;
      call.AssistSupervisor = true;
      call.Transfer = false;
      call.Merge = false;
      call.inConferance = true;
      modifyCallList.push(call);
    });
    dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
    localStorage.setItem("callList", JSON.stringify(modifyCallList));
  } else {
    dispatch({ type: "SET_CALL_LIST", val: callList });
    localStorage.setItem("callList", JSON.stringify(callList));
  }
};
export const changeIsConfer = (responseData) => (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.inConference = true;
    }
    modifyCallList.push(call);
  });
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const holdCall = (responseData) => (dispatch) => {
  console.log("main in hold");
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];

  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Hold = false;
    }
    modifyCallList.push(call);
  });
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const unHoldCall = (responseData) => (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Hold = true;
    }
    modifyCallList.push(call);
  });
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const muteCall = (responseData, cli) => (dispatch) => {
  console.log("mute", responseData);
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Mute = false;
    }
    modifyCallList.push(call);
  });
  cli.doMute(localStorage.getItem("callId"));
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const unMuteCall = (responseData, cli) => (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Mute = true;
    }
    modifyCallList.push(call);
  });
  cli.doUnMute(localStorage.getItem("callId"));
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const ConsultedHoldCall = (responseData) => (dispatch) => {
  console.log("i made consulted call main call should be in hold");
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Hold = false;
      call.Dialer = false;
      call.AssistSupervisor = false;
      call.Transfer = true;
      call.Merge = true;
    }
    modifyCallList.push(call);
  });
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
export const swapTransferCallToMainCall = (responseData) => (dispatch) => {
  let callList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  callList.map((call) => {
    call.Mute = true;
    call.Hold = true;
    call.Dialer = true;
    call.AssistSupervisor = true;
    call.Transfer = false;
    call.Merge = false;
    call.Bargin = false;
    call.Couch = false;
    call.callType = responseData.callType;
    call.phone = responseData.callingDeviceID;
    call.calledDeviceID = responseData.calledDeviceID;
    call.callerId = responseData.callerId;
    call.callingAgentName = responseData.callingAgentName;
    call.callingDeviceID = responseData.callingDeviceID;
    call.contactId = responseData.contactId;
    call.event = responseData.event;
    call.externalContactId = responseData.externalContactId;
    call.mainContactId = null;
    call.reason = responseData.reason;
    call.skillSet = responseData.skillSet;
    call.thirdPartyDeviceID = responseData.thirdPartyDeviceID;
    call.uuiData = responseData.uuiData;
    modifyCallList.push(call);
  });
  let newcontactlist = [];
  JSON.parse(localStorage.getItem("contactList")).map((client) => {
    if (client.voice_contactId == localStorage.getItem("contactId")) {
      client.voice_contactId = localStorage.getItem("mainContactId");
      client.phonenumber = responseData.callingDeviceID;
      client.unique_id.phonenumber = responseData.callingDeviceID;
      try {
        const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
        axios
          .post(
            BaseUrl + "/users/updateClient",
            {
              id: client.unique_id.id,
              agent_id: loggedInAgent.id,
              chat_session_id: client.chat_session_id,
              phonenumber: responseData.callingDeviceID,
              voice_contactId: localStorage.getItem("mainContactId"),
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
                tenantId: localStorage.getItem("TenantId"),
              },
            },
          )
          .then((res) => {
            if (res.data.status) {
              dispatch({
                type: SET_EXTERNAL_CHAT_DATA,
                val: res.data.session[0],
              });
            } else {
            }
          })
          .catch((error) => {});
      } catch (error) {}
    }
    newcontactlist.push(client);
  });
  localStorage.setItem("contactId", localStorage.getItem("mainContactId"));
  dispatch({ type: SET_CONTACT_LIST, val: [...newcontactlist] });
  localStorage.setItem("contactList", JSON.stringify([...newcontactlist]));
  localStorage.setItem("incomingNumber", responseData.callingDeviceID);
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
  localStorage.removeItem("mainContactId");
};
export const convertBarginCallToMainCall = (responseData) => (dispatch) => {
  let newCallList = JSON.parse(localStorage.getItem("callList")) || [];
  var modifyCallList = [];
  newCallList.map((call) => {
    if (call.contactId == responseData.contactId) {
      call.Bargin = false;
    }
    modifyCallList.push(call);
  });
  dispatch({ type: "SET_CALL_LIST", val: modifyCallList });
  localStorage.setItem("callList", JSON.stringify(modifyCallList));
};
const CRM_VOICE_POP_UP = () => {
  let body = {
    phonenumber: localStorage.getItem("dailedNumber"),
    skillset: "customer service",
    channel: "voice",
    type: localStorage.getItem("type"),
    reg_no: localStorage.getItem("Contactreg_no"),
    contact_id: localStorage.getItem("ContactVoiceId"),
  };
  axios
    .post(BaseUrl + "/ticket/crmscreenpop", body, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
        tenantId: localStorage.getItem("TenantId"),
      },
    })
    .then((res) => {
      window.open(res.data.data);
      toast.success("CRM Generated", toaststyle);
      localStorage.removeItem("callDirectionType");
      localStorage.removeItem("ClickToCall");
      localStorage.removeItem("DCC_CALL");
    })
    .catch((error) => {
      toast.warning("screen pop url not generated", toaststyle);
      localStorage.removeItem("callDirectionType");
      localStorage.removeItem("ClickToCall");
      localStorage.removeItem("DCC_CALL");
    });
};
const unhold_call = async (contactId) => {
  let AvcUrl = localStorage.getItem("AvcUrl");
  await axios
    .post(
      AvcUrl +
        `/voice/terminal/${localStorage.getItem("agentLoginTerminalId")}/unhold/${contactId}`,
      {},
      {
        headers: {
          ssoToken: localStorage.getItem("ssoToken"),
        },
      },
    )
    .then(async (res) => {
      if ((res.data.status = "OK")) {
        DummyReport("unhold_call", {
          contactId: contactId,
        });
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
export function CustomerNameApi(phonenumber) {
  return async (dispatch) => {
    let datas = {
      phone: phonenumber,
    };
    await axios
      .post(BaseUrl + "/users/customername", datas, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("CustomerNameApi", res);
        dispatch({ type: "SET_DIALED_NUMBER_INC", val: res.data.data });
      })
      .catch((err) => {
        console.log("CustomerNameApi", err);
      });
  };
}
// voice channel ------------------------------------------------------------------------------------------------------------

// CustomerPortal channel ---------------------------------------------------------------------------------------------------
export const setshowChatForm = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_CHAT_FORM, val });
};
export const setshowForm = (val) => (dispatch) => {
  dispatch({ type: SET_SHOW_FORM, val });
};
export const setChatData = (val) => (dispatch) => {
  dispatch({ type: SET_CHAT_DATA, val });
};
export const setAgentLeft = (val) => (dispatch) => {
  dispatch({ type: SET_AGENT_LEFT, val });
};
export const setChatType = (val) => (dispatch) => {
  dispatch({ type: SET_CHAT_TYPE, val });
};
// CustomerPortal channel ---------------------------------------------------------------------------------------------------
